document.addEventListener('DOMContentLoaded', function () {

  // NAV scroll effect
  const nav = document.getElementById('main-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.style.background = window.scrollY > 40 ? 'rgba(8,8,8,0.99)' : 'rgba(8,8,8,0.95)';
    });
  }

  // Mobile menu toggle
  const toggle = document.getElementById('nav-toggle');
  const mobileMenu = document.getElementById('mobile-menu');
  if (toggle && mobileMenu) {
    toggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('open');
      const bars = toggle.querySelectorAll('span');
      if (isOpen) {
        bars[0].style.transform = 'rotate(45deg) translate(5px,5px)';
        bars[1].style.opacity = '0';
        bars[2].style.transform = 'rotate(-45deg) translate(5px,-5px)';
      } else {
        bars[0].style.transform = '';
        bars[1].style.opacity = '';
        bars[2].style.transform = '';
      }
    });
    mobileMenu.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        toggle.querySelectorAll('span').forEach(s => { s.style.transform = ''; s.style.opacity = ''; });
      });
    });
  }

  // Scroll reveal
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.08 });
    reveals.forEach(r => observer.observe(r));
  }

  // FAQ accordion
  document.querySelectorAll('.faq-question').forEach(q => {
    q.addEventListener('click', () => {
      const item = q.parentElement;
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });

});

/* ==============================
   LIGHTBOX — full featured
   ============================== */
var _lbScale = 1;
var _lbIndex = 0;
var _lbImages = [];
var _lbDragging = false;
var _lbDragStart = { x: 0, y: 0 };
var _lbOffset = { x: 0, y: 0 };
var _lbLastOffset = { x: 0, y: 0 };

function openLightbox(index) {
  _lbImages = window._productImages || [];
  if (!_lbImages.length) return;
  _lbIndex = index || 0;
  _lbScale = 1;
  _lbOffset = { x: 0, y: 0 };
  _lbLastOffset = { x: 0, y: 0 };

  var lb = document.getElementById('lightbox');
  var img = document.getElementById('lightbox-img');
  img.src = _lbImages[_lbIndex];
  img.style.transform = 'translate(0px, 0px) scale(1)';
  lb.classList.add('open');
  document.body.style.overflow = 'hidden';
  _updateCounter();
}

function closeLightbox(e) {
  if (e) e.stopPropagation();
  document.getElementById('lightbox').classList.remove('open');
  document.body.style.overflow = '';
  _lbScale = 1;
  _lbOffset = { x: 0, y: 0 };
}

function lightboxPrev(e) {
  if (e) e.stopPropagation();
  if (!_lbImages.length) return;
  _lbIndex = (_lbIndex - 1 + _lbImages.length) % _lbImages.length;
  _lbScale = 1;
  _lbOffset = { x: 0, y: 0 };
  _lbLastOffset = { x: 0, y: 0 };
  var img = document.getElementById('lightbox-img');
  img.src = _lbImages[_lbIndex];
  img.style.transform = 'translate(0px, 0px) scale(1)';
  _updateCounter();
  // sync thumbnail
  var thumbs = document.querySelectorAll('.gallery-thumb');
  thumbs.forEach(function(t, i) { t.classList.toggle('active', i === _lbIndex); });
}

function lightboxNext(e) {
  if (e) e.stopPropagation();
  if (!_lbImages.length) return;
  _lbIndex = (_lbIndex + 1) % _lbImages.length;
  _lbScale = 1;
  _lbOffset = { x: 0, y: 0 };
  _lbLastOffset = { x: 0, y: 0 };
  var img = document.getElementById('lightbox-img');
  img.src = _lbImages[_lbIndex];
  img.style.transform = 'translate(0px, 0px) scale(1)';
  _updateCounter();
  var thumbs = document.querySelectorAll('.gallery-thumb');
  thumbs.forEach(function(t, i) { t.classList.toggle('active', i === _lbIndex); });
}

function _updateCounter() {
  var el = document.getElementById('lightbox-counter');
  if (el && _lbImages.length > 1) {
    el.textContent = (_lbIndex + 1) + ' / ' + _lbImages.length;
  }
}

function _applyTransform() {
  var img = document.getElementById('lightbox-img');
  img.style.transform = 'translate(' + _lbOffset.x + 'px, ' + _lbOffset.y + 'px) scale(' + _lbScale + ')';
}

function lbZoomIn(e) {
  if (e) e.stopPropagation();
  _lbScale = Math.min(_lbScale + 0.4, 5);
  _applyTransform();
}

function lbZoomOut(e) {
  if (e) e.stopPropagation();
  _lbScale = Math.max(_lbScale - 0.4, 0.5);
  if (_lbScale <= 1) { _lbOffset = { x: 0, y: 0 }; }
  _applyTransform();
}

function lbZoomReset(e) {
  if (e) e.stopPropagation();
  _lbScale = 1;
  _lbOffset = { x: 0, y: 0 };
  _lbLastOffset = { x: 0, y: 0 };
  _applyTransform();
}

// Mouse wheel zoom
document.addEventListener('wheel', function(e) {
  var lb = document.getElementById('lightbox');
  if (!lb || !lb.classList.contains('open')) return;
  e.preventDefault();
  if (e.deltaY < 0) {
    _lbScale = Math.min(_lbScale + 0.2, 5);
  } else {
    _lbScale = Math.max(_lbScale - 0.2, 0.5);
    if (_lbScale <= 1) _lbOffset = { x: 0, y: 0 };
  }
  _applyTransform();
}, { passive: false });

// Keyboard controls
document.addEventListener('keydown', function(e) {
  var lb = document.getElementById('lightbox');
  if (!lb || !lb.classList.contains('open')) return;
  if (e.key === 'Escape') closeLightbox();
  if (e.key === 'ArrowLeft') lightboxPrev();
  if (e.key === 'ArrowRight') lightboxNext();
  if (e.key === '+' || e.key === '=') lbZoomIn();
  if (e.key === '-') lbZoomOut();
});

// Drag to pan
document.addEventListener('DOMContentLoaded', function() {
  var img = document.getElementById('lightbox-img');
  if (!img) return;

  img.addEventListener('mousedown', function(e) {
    if (_lbScale <= 1) return;
    _lbDragging = true;
    _lbDragStart = { x: e.clientX - _lbOffset.x, y: e.clientY - _lbOffset.y };
    img.style.cursor = 'grabbing';
    e.preventDefault();
  });

  document.addEventListener('mousemove', function(e) {
    if (!_lbDragging) return;
    _lbOffset.x = e.clientX - _lbDragStart.x;
    _lbOffset.y = e.clientY - _lbDragStart.y;
    _applyTransform();
  });

  document.addEventListener('mouseup', function() {
    _lbDragging = false;
    var img = document.getElementById('lightbox-img');
    if (img) img.style.cursor = _lbScale > 1 ? 'grab' : 'default';
  });

  // Touch support for mobile pinch/drag
  var _touchStart = [];
  var _startDist = 0;
  var _startScale = 1;

  img.addEventListener('touchstart', function(e) {
    if (e.touches.length === 2) {
      _startDist = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );
      _startScale = _lbScale;
    } else if (e.touches.length === 1) {
      _lbDragging = true;
      _lbDragStart = { x: e.touches[0].clientX - _lbOffset.x, y: e.touches[0].clientY - _lbOffset.y };
    }
    e.preventDefault();
  }, { passive: false });

  img.addEventListener('touchmove', function(e) {
    if (e.touches.length === 2) {
      var dist = Math.hypot(
        e.touches[0].clientX - e.touches[1].clientX,
        e.touches[0].clientY - e.touches[1].clientY
      );
      _lbScale = Math.min(Math.max(_startScale * (dist / _startDist), 0.5), 5);
      _applyTransform();
    } else if (e.touches.length === 1 && _lbDragging) {
      _lbOffset.x = e.touches[0].clientX - _lbDragStart.x;
      _lbOffset.y = e.touches[0].clientY - _lbDragStart.y;
      _applyTransform();
    }
    e.preventDefault();
  }, { passive: false });

  img.addEventListener('touchend', function() {
    _lbDragging = false;
    if (_lbScale <= 1) _lbOffset = { x: 0, y: 0 };
  });
});

/* ==============================
   ACCORDION (global)
   ============================== */
function toggleAccordion(trigger) {
  var item = trigger.parentElement;
  var body = item.querySelector('.accordion-body');
  var icon = trigger.querySelector('.accordion-icon');
  var isOpen = item.classList.contains('open');
  document.querySelectorAll('.accordion-item').forEach(function(i) {
    i.classList.remove('open');
    var b = i.querySelector('.accordion-body');
    var ic = i.querySelector('.accordion-icon');
    if (b) b.style.maxHeight = '0';
    if (ic) ic.textContent = '+';
  });
  if (!isOpen) {
    item.classList.add('open');
    body.style.maxHeight = body.scrollHeight + 'px';
    icon.textContent = '−';
  }
}

/* ==============================
   VARIANT + QTY (global)
   ============================== */
function switchImage(src, thumb, index) {
  var mainImg = document.getElementById('main-image');
  if (mainImg) mainImg.src = src;
  document.querySelectorAll('.gallery-thumb').forEach(function(t) { t.classList.remove('active'); });
  thumb.classList.add('active');
  window._lbIndex = index;
}

function selectVariant(btn) {
  document.querySelectorAll('.variant-btn').forEach(function(b) { b.classList.remove('active'); });
  btn.classList.add('active');
  var idInput = document.getElementById('variant-id');
  var priceEl = document.getElementById('cart-price');
  var titleEl = document.getElementById('selected-variant-title');
  if (idInput) idInput.value = btn.dataset.variantId;
  if (priceEl) priceEl.textContent = btn.dataset.variantPrice;
  if (titleEl) titleEl.textContent = btn.dataset.variantTitle;
}

function changeQty(delta) {
  var input = document.getElementById('qty-input');
  if (input) input.value = Math.max(1, Math.min(10, parseInt(input.value) + delta));
}
